import {TicketDetails} from "@/features/ticket";

export interface IDriveThruCarEvent {
    id: string;
    /** Seconds since business-day midnight (Fct_SOSTotal.SecOfDay). */
    secondOfDay: number;
    orderStationSeconds: number | null;
    paymentWindowSeconds: number | null;
    presentationWindowSeconds: number | null;
    totalServiceSeconds: number;
    isOverThreshold: boolean;
    vehicleNumber: number;
    transactionId: string;
    cashierName: string;
}

export interface IDriveThruTransaction {
    transactionId: string;
    orderNumber: string;
    ticket: TicketDetails | null;
}

// Mirrors the server `CascadeCategory` enum
export enum CascadeCategory {
    None = "",
    Cascade = "Cascade",
    Affected = "Affected",
    Isolated = "Isolated"
}

export interface IDriveThruReplayExperience {
    cascadeTrigger: CascadeCategory;
    cascadeGroupId: number;
    secondOfDay: number;
    totalSec: number | null;
    menuSec: number | null;
    queueSec: number | null;
    windowSec: number | null;
    orderNumber: string | null;
    empName: string | null;
    ticket: TicketDetails | null;
}

export interface IDriveThruReplayResponse {
    experiences: IDriveThruReplayExperience[];
}

export interface ICamera {
    id: string;
    name: string;
}

export interface ICameraFeedResponse {
    cameras: ICamera[];
    startDateTime: string;
    endDateTime: string;
    videoBaseUrl: string;
    ssoLoginUrl: string;
}

export enum BottleneckStation {
    Menu = "Menu",
    Queue = "Queue",
    Window = "Window"
}

export interface CascadeInfo {
    category: CascadeCategory;
    positionIndex: number;
    groupId: number;
    bottleneckStation: BottleneckStation | null;
    cascadeLength: number;
}
